import React, { useState } from "react";
import { auth, db } from "../config/firebase";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { useForm } from "react-hook-form";
import { doc, setDoc } from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BackgroundImage from "../Components/Background";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const navigate = useNavigate();
  const {
    handleSubmit,
    formState: { errors },
    register,
    watch,
  } = useForm();
  
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  async function onhandleSubmit(data) {
    const { email, password, name } = data;
    try {
      const userCredentials = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      toast.success("User Created Successfully", { position: "top-center" });
      navigate("/");

      const user = userCredentials.user;

      await updateProfile(auth.currentUser, {
        displayName: name,
      });
      if (user) {
        await setDoc(doc(db, "users", user.uid), {
          profile: {
            email: user.email,
            name: name,
            createdAt: new Date(),
            reviews: {
              movie: [],
              tv: [],
              people: [],
            },
            favourites: {
              movie: [],
              tv: [],
              people: [],
            },
          },
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("User creation failed", { position: "top-center" });
    }
  }

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-black bg-opacity-60">
      <BackgroundImage />

      <div className="absolute inset-0 bg-black opacity-60 z-10"></div>

      <div className="relative z-20 bg-slate-900/50 backdrop-blur-sm rounded-lg p-6 border border-gray-100/20 max-w-lg w-full p-8">
        <h2 className="text-3xl newfont font-semibold text-yellow-400 text-center mb-6">
          Create Your Account
        </h2>

        <form onSubmit={handleSubmit(onhandleSubmit)} className="space-y-6">
          <div>
            <label className="text-sm font-medium text-yellow-400 tracking-wider newfont">Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i,
                  message: "Invalid email format",
                },
              })}
              className="w-full p-3 mt-2 text-white bg-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-300"
            />
            {errors.email && (
              <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>
            )}
          </div>

          <div>
            <label className="text-sm font-medium text-yellow-400 tracking-wider newfont">Password</label>
            <div className="relative">
              <input
                type={passwordVisible ? "text" : "password"}
                placeholder="Enter your password"
                {...register("password", {
                  required: "Password is required",
                  minLength: { value: 6, message: "Minimum 6 characters" },
                })}
                className="w-full p-3 mt-2 text-white bg-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-300"
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 transform -translate-y-1/2"
                onClick={() => setPasswordVisible(!passwordVisible)}
              >
                {passwordVisible ? (
                  <FaEyeSlash className="text-yellow-400" />
                ) : (
                  <FaEye className="text-yellow-400" />
                )}
              </button>
            </div>
            {errors.password && (
              <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>
            )}
          </div>

          <div>
            <label className="text-sm font-medium text-yellow-400 tracking-wider newfont">Confirm Password</label>
            <div className="relative">
              <input
                type={confirmPasswordVisible ? "text" : "password"}
                placeholder="Confirm your password"
                {...register("confirmPassword", {
                  required: "Please confirm your password",
                  validate: (value) =>
                    value === watch("password") || "Passwords do not match",
                })}
                className="w-full p-3 mt-2 text-white bg-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-300"
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 transform -translate-y-1/2"
                onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
              >
                {confirmPasswordVisible ? (
                  <FaEyeSlash className="text-yellow-400" />
                ) : (
                  <FaEye className="text-yellow-400" />
                )}
              </button>
            </div>
            {errors.confirmPassword && (
              <p className="text-red-500 text-xs mt-1">
                {errors.confirmPassword.message}
              </p>
            )}
          </div>

          <div>
            <label className="text-sm font-medium text-yellow-400 tracking-wider newfont">Name</label>
            <input
              type="text"
              placeholder="Enter your full name"
              {...register("name", {
                required: "Name is required",
              })}
              className="w-full p-3 mt-2 text-white bg-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-300"
            />
            {errors.name && (
              <p className="text-red-500 text-xs mt-1">{errors.name.message}</p>
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
            <button
              type="submit"
              className="w-full py-3 tracking-wider newfont text-white bg-gradient-to-r from-amber-200/90 to-yellow-400/90 rounded-lg hover:scale-105 transform transition-all"
            >
              Sign Up
            </button>

            <span className="text-sm text-white tracking-wider newfont">
              Already have an account?{" "}
              <button
                type="button"
                onClick={() => navigate("/login")}
                className="text-amber-300 hover:text-amber-400 transition-colors"
              >
                Log In
              </button>
            </span>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default SignUp;
